import notify from './../notify';
import service from './../../services';

export default {
  /**
   * Retorna Ativo/Inativo conforme a avaliação da expressão
   * @param value valor a ser comparado
   * @returns 'Ativo' ou 'Inativo'
   */
  getAtivoInativo(value) {
    return value ? 'Ativo' : 'Inativo';
  },

  /**
   * Retorna cor conforme avaliação da expressão
   * @param {any} value valor a ser avaliado
   * @returns 'sucess' ou 'danger'
   */
  getColorAtivoInativo(value) {
    return value ? 'success' : 'danger';
  },

  /**
   * Retorna Ativo/Inativo conforme a avaliação da coluna deletedAt
   * @param value valor a ser comparado
   * @returns 'Ativo' ou 'Inativo'
   */
  getAtivoInativoByDeletedAt(value) {
    return value ? 'Inativo' : 'Ativo';
  },

  /**
   * Retorna cor conforme avaliação da coluna deletedAt
   * @param {any} value valor a ser avaliado
   * @returns 'sucess' ou 'danger'
   */
  getColorAtivoInativoByDeletedAt(value) {
    return value ? 'danger' : 'success';
  },

  /**
   * Validação de Formulário
   */
  validateState(fields, errors, ref) {
    if (fields[ref] && (fields[ref].dirty || fields[ref].validated)) {
      return !errors.has(ref);
    }
    return true;
  },

  /**
   * Retorna uma class CSS na validação de Formulário
   */
  validateStateClass(fields, errors, ref) {
    const result = !this.validateState(fields, errors, ref) ? 'has-error' : '';
    return result;
  },

  /**
   * Inativar/Reativar os registro
   * @param {object} objectVs this.$vs
   * @param {object} selected registros selecionads
   * @param {string} keyID nome da propriedade que identifica o registro (ID)
   * @param {string} ControllerApi nome do controller
   * @param {string} ActionApi nome da action (Ex: Inativar/Reativar)
   */
  inativarRegistros(objectVs, selected, keyID, ControllerApi, ActionApi) {
    return new Promise(async (resolve) => {
      try {
        if (!(objectVs && selected && ControllerApi && ActionApi)) {
          throw 'Erro ao inativar';
        }

        if (selected.length == 0) {
          notify.notifyFail(objectVs, 'Selecione pelo menos um registro');
          return resolve(false);
        }

        objectVs.loading();

        const listIDs = recuperaListID(selected, keyID);
        console.log(listIDs);
        await service.post(ControllerApi, ActionApi, { ids: listIDs });

        resolve(true);
      } catch (error) {
        notify.notifyFail(objectVs, error);
        resolve(false);
      } finally {
        objectVs.loading.close();
      }
    });
  },
};

const recuperaListID = (arrayItems, keyID) => {
  const result = [];
  arrayItems.forEach((element) => {
    result.push(element[keyID]);
  });
  return result;
};
